import { Controller } from "@hotwired/stimulus"

// Generic: when the page loads with a URL hash matching this controller's
// anchor value, move focus to the controller's element heading. Required
// for WCAG 2.4.3 when navigating via deep-link — browser-native scroll
// moves the viewport but doesn't move screen-reader focus.
export default class extends Controller {
  static values = { anchor: String }

  connect() {
    if (window.location.hash !== `#${this.anchorValue}`) return
    requestAnimationFrame(() => {
      const heading = this.element.querySelector("h1, h2, h3, h4, h5, h6")
      if (heading) {
        if (!heading.hasAttribute("tabindex")) heading.setAttribute("tabindex", "-1")
        heading.focus({ preventScroll: false })
      }
    })
  }
}
